import React, { useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Tooltip,
  Avatar,
  IconButton,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import InfoIcon from "@mui/icons-material/Info";
import UpcomingPhases from "./UpcomingPhases";
import ReportModal from "./ReportModal";
import styles from "../../../styles/adminPortal.module.css";
import ProductTimelineAccordion from "./ProductTimeLine";
import Swal from "sweetalert2";
import axios from "axios";
import GlobalButton from "../../../shared/utils/GlobalButton";

const ProjectTimeline = ({
  CampaignDetails,
  getCampaignDetails,
  setCampaignDetails,
}) => {
  const sortedProducts = React.useMemo(() => {
    return groupByStateCityAndStore(
      CampaignDetails?.sortedStateWiseJobs.filter(
        (ele) => ele.isDeleted == false || ele.isDeleted == null,
      ) || [],
    );
  }, [CampaignDetails?.sortedStateWiseJobs]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  const [filteredProducts, setFilteredProducts] = useState(sortedProducts);
  const [searchInputsByState, setSearchInputsByState] = useState({});
  const [expandedStore, setExpandedStore] = useState(null);

  const toggleStoreTimeline = (storeId) => {
    setExpandedStore(expandedStore === storeId ? null : storeId);
  };
  const handleDeleteStore = async (store) => {
    const serverURL = process.env.REACT_APP_URL;

    let allProductIds = store?.products?.map((ele) => ele.productId);

    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This store will be deleted permanently",

      icon: "warning",

      showCancelButton: true,

      confirmButtonColor: "#d33",

      confirmButtonText: "Yes, delete it",
    });

    if (!result.isConfirmed) return;

    try {
      const token = localStorage.getItem("token");

      const response = await axios.put(
        `${serverURL}/jobs/deleteStore`,
        { productIds: allProductIds },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (response.data.success) {
        getCampaignDetails();
        Swal.fire({
          icon: "success",
          title: "Deleted",
          text: response.data.message,
        });
        setCampaignDetails((prev) => ({
          ...prev,

          sortedStateWiseJobs: prev.sortedStateWiseJobs.map((job) => {
            const hasDeletedProduct = allProductIds.includes(
              job.productId?.toString(),
            );

            return hasDeletedProduct
              ? {
                  ...job,
                  isDeleted: true,
                }
              : job;
          }),

          locations: prev.locations.map((loc) => {
            const hasDeletedProduct = allProductIds.includes(
              loc.product?.productId?.toString(),
            );

            if (!hasDeletedProduct) return loc;

            return {
              ...loc,

              product: {
                ...loc.product,

                isDeleted: true,

                jobs:
                  loc.product.jobs?.map((job) => ({
                    ...job,
                    isDeleted: true,
                  })) || [],
              },
            };
          }),
        }));
      }

      // fetchStores();
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.message || "Delete failed",
      });
    }
  };

  const handleSearchChangeHead = (e, key, stateName) => {
    const value = e.target.value.toLowerCase();

    // update searchInputs state
    const updatedInputs = {
      ...searchInputsByState,
      [stateName]: {
        ...searchInputsByState[stateName],
        [key]: value,
      },
    };
    setSearchInputsByState(updatedInputs);

    // filter logic
    const newFiltered = sortedProducts
      ?.map((stateGroup) => {
        const searchInputs = updatedInputs[stateGroup?.stateName] || {};

        const filteredCities = stateGroup.cities
          .map((city) => {
            const filteredStores = city.stores.filter((store) => {
              return Object.entries(searchInputs).every(
                ([filterKey, filterValue]) => {
                  const storeValue = store[filterKey];
                  return (
                    typeof storeValue === "string" &&
                    storeValue.toLowerCase().includes(filterValue)
                  );
                },
              );
            });

            return {
              ...city,
              stores: filteredStores,
            };
          })
          .filter((city) => city?.stores?.length > 0);

        return {
          ...stateGroup,
          cities: filteredCities,
        };
      })
      .filter((stateGroup) => stateGroup?.cities?.length > 0);

    setFilteredProducts(newFiltered);
  };

  React.useEffect(() => {
    setFilteredProducts(sortedProducts);
  }, [sortedProducts]);

  return (
    <div className="w-full py-4 ">
      {sortedProducts?.map((state, stateIndex) => (
        <Accordion
          key={stateIndex}
          className="border border-gray-300 rounded my-2"
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            className="bg-gray-100"
          >
            <div className="flex justify-between w-full">
              <Typography className="font-medium">
                {state?.stateName}
              </Typography>
              <Typography className="text-gray-500">
                {`${state?.cities?.reduce((acc, city) => {
                  return acc + (city?.stores?.length || 0);
                }, 0)}
                Sites`}
              </Typography>
            </div>
          </AccordionSummary>

          <AccordionDetails className="relative pt-4">
            <div className="relative max-h-[400px] min-h-[400px] overflow-y-auto overflow-x-auto">
              <table className="w-full text-sm text-left rtl:text-right text-gray-500 ">
                <thead className="sticky top-0 bg-white z-20">
                  <tr>
                    <th scope="col" className="px-6 py-3 align-top w-[13%]">
                      <div className="flex flex-col items-start">
                        <span>City</span>
                        <input
                          type="text"
                          className={styles.searchInput}
                          placeholder="Search..."
                          onChange={(e) =>
                            handleSearchChangeHead(e, "city", state?.stateName)
                          }
                          value={
                            searchInputsByState[state?.stateName]?.["city"] ||
                            ""
                          }
                        />
                      </div>
                    </th>

                    <th scope="col" className="px-6 py-3 align-top w-[30%]">
                      <div className="flex flex-col items-start">
                        <span>Store Name</span>
                        <input
                          type="text"
                          className={styles.searchInput}
                          placeholder="Search Store Name..."
                          onChange={(e) =>
                            handleSearchChangeHead(
                              e,
                              "storeName",
                              state?.stateName,
                            )
                          }
                          // value={searchInputs?.["storeName"] || ""}
                          value={
                            searchInputsByState[state?.stateName]?.[
                              "storeName"
                            ] || ""
                          }
                        />
                      </div>
                    </th>

                    <th scope="col" className="px-6 py-3 align-top w-[15%]">
                      <span>Store Owner Name</span>
                    </th>

                    <th scope="col" className="px-6 py-3 align-top w-[15%]">
                      <span>Store Owner Number</span>
                    </th>
                    <th scope="col" className="px-6 py-3 align-top w-[15%]">
                      <span>Store Product</span>
                    </th>

                    <th scope="col" className="px-6 py-3 align-top w-[10%]">
                      <span>Rejected Jobs</span>
                    </th>

                    <th scope="col" className="px-6 py-3 align-top w-[15%]">
                      <span>Action</span>
                    </th>
                  </tr>
                </thead>
                {(() => {
                  const filteredState = filteredProducts?.find(
                    (pd) => pd.stateName === state?.stateName,
                  );

                  if (!filteredState || !filteredState.cities?.length) {
                    return (
                      <tbody>
                        <tr>
                          <td
                            colSpan="7"
                            className="text-center py-4 text-gray-500"
                          >
                            No data found.
                          </td>
                        </tr>
                      </tbody>
                    );
                  }

                  return filteredState.cities.map((city, cityIndex) => (
                    <tbody className="text-start h-2/5" key={cityIndex}>
                      {city.stores.map((store, storeIndex) => {
                        const hasAssignedIP = store.products?.some((product) =>
                          product.jobs?.some(
                            (job) => job?.installationPartnerId,
                          ),
                        );
                        const hasAssignedVendor = store.products?.some(
                          (product) => product?.vendorId,
                        );
                        let checkDeleteBtnEnabled =
                          hasAssignedIP || hasAssignedVendor;

                        const rejectedCount = store?.products?.reduce(
                          (acc, product) => {
                            const rejectedJobs = product?.jobs?.filter(
                              (j) =>
                                j?.approval?.adminStatus === -1 ||
                                j?.approval?.clientStatus === -1,
                            )?.length;

                            return acc + (rejectedJobs || 0);
                          },
                          0,
                        );

                        const totalCount = store?.products?.reduce(
                          (acc, product) => {
                            const jobsWithServiceTypeZero =
                              product?.jobs?.filter(
                                (j) =>
                                  j?.serviceType === 0 ||
                                  j?.serviceType === "0",
                              )?.length || 0;
                            return acc + jobsWithServiceTypeZero;
                          },
                          0,
                        );

                        return (
                          <React.Fragment key={storeIndex}>
                            <tr key={storeIndex} className="bg-white border-b">
                              {/* City */}
                              <td className="px-6 py-4">
                                <div className="font-semibold whitespace-nowrap">
                                  {city.cityName}
                                </div>
                              </td>

                              {/* Address + Store */}
                              <td className="px-6 py-4">
                                {/* <div className="font-semibold">
                                  {store.storeName}
                                </div> */}
                                <div className="flex items-center gap-2 flex-wrap">
                                  <div className="font-semibold">
                                    {store.storeName}
                                  </div>

                                  {/* {isOverDue && ( */}
                                  {/* <span className="px-2 py-1 text-[10px] font-semibold rounded-full bg-red-100 text-red-600 border border-red-300">
                                    Over Due
                                  </span> */}
                                  {/* )} */}
                                </div>
                                <div className="w-40 sm:w-40 md:w-80">
                                  {store.address}, {store.zipCode}
                                </div>
                              </td>

                              {/* Owner Name */}
                              <td className="px-6 py-4 whitespace-nowrap">
                                {store.ownerName}
                              </td>

                              {/* Owner Phone */}
                              <td className="px-6 py-4">{store.ownerPhone}</td>

                              {/* Store Products */}
                              <td className="px-6 py-4">
                                {(() => {
                                  const mergedProducts = Object.values(
                                    store.products.reduce((acc, product) => {
                                      const { productId, jobs } = product;
                                      if (!acc[productId]) {
                                        acc[productId] = {
                                          ...product,
                                          jobs: [...jobs],
                                        };
                                      } else {
                                        acc[productId].jobs = [
                                          ...acc[productId].jobs,
                                          ...jobs,
                                        ];
                                      }
                                      return acc;
                                    }, {}),
                                  );

                                  const extraCount = mergedProducts.length - 1;

                                  return (
                                    <div className="flex items-center gap-1">
                                      {/* Show first product */}
                                      <span className="px-2 py-1 text-xs bg-gray-200 rounded whitespace-nowrap">
                                        {mergedProducts.length > 0
                                          ? mergedProducts[0].productType
                                          : "No Product"}
                                      </span>

                                      {/* +N with tooltip for all products */}
                                      {extraCount > 0 && (
                                        <Tooltip
                                          arrow
                                          title={
                                            <div className="bg-grey p-2 rounded shadow-md">
                                              {mergedProducts.map((p, i) => (
                                                <div
                                                  key={i}
                                                  className="font-semibold"
                                                >
                                                  {i + 1}. {p.productType}
                                                </div>
                                              ))}
                                            </div>
                                          }
                                        >
                                          <span className="px-2 py-1 text-xs bg-white-200 rounded whitespace-nowrap cursor-pointer hover:bg-gray-300">
                                            +{extraCount}
                                          </span>
                                        </Tooltip>
                                      )}
                                    </div>
                                  );
                                })()}
                              </td>

                              {/* Rejected jobs count */}
                              <td className="px-6 py-4 whitespace-nowrap">
                                <Tooltip
                                  title={`${rejectedCount} rejected out of ${totalCount}`}
                                  arrow
                                >
                                  <div className="flex items-center justify-center space-x-2">
                                    <span className="px-2 py-0.5 text-xs rounded bg-red-50 text-red-600 font-medium">
                                      {rejectedCount}
                                    </span>
                                    <span className="text-gray-300">/</span>
                                    <span className="text-sm text-gray-600">
                                      {totalCount}
                                    </span>
                                  </div>
                                </Tooltip>
                              </td>

                              {/* View button */}
                              <td className="px-6 py-4 whitespace-nowrap">
                                <div className="flex flex-col gap-2">
                                  {/* Timeline Button */}
                                  <GlobalButton
                                    variant="tertiary"
                                    size="small"
                                    onClick={() =>
                                      toggleStoreTimeline(store.id)
                                    }
                                  >
                                    {expandedStore === store.id
                                      ? "Hide Timeline"
                                      : "View Timeline"}
                                  </GlobalButton>

                                  {/* Delete Button */}
                                  {!checkDeleteBtnEnabled && (
                                    <GlobalButton
                                      variant="warning"
                                      size="small"
                                      onClick={() => handleDeleteStore(store)}
                                    >
                                      {`Delete`}
                                    </GlobalButton>
                                  )}
                                </div>
                              </td>
                            </tr>
                            {expandedStore === store.id && (
                              <tr>
                                <td colSpan="7" className="bg-gray-50 p-4 ">
                                  {Object.values(
                                    store.products.reduce((acc, product) => {
                                      const { productId, jobs } = product;

                                      if (!acc[productId]) {
                                        // first time seeing this productId → store full product
                                        acc[productId] = {
                                          ...product,
                                          jobs: [...jobs],
                                        };
                                      } else {
                                        // merge jobs into existing product
                                        acc[productId].jobs = [
                                          ...acc[productId].jobs,
                                          ...jobs,
                                        ];
                                      }

                                      return acc;
                                    }, {}),
                                  ).map((mergedProduct, idx) => (
                                    <ProductTimelineAccordion
                                      key={idx}
                                      product={mergedProduct}
                                      job={mergedProduct.jobs}
                                      CampaignDetails={CampaignDetails}
                                      getCampaignDetails={getCampaignDetails}
                                    />
                                  ))}
                                </td>
                              </tr>
                            )}

                            {/* {expandedStore === store.id && (
                            <tr>
                              <td colSpan="6" className="bg-gray-50 p-4">
                                <div className="space-y-4">
                                  {store.products.map((product, pIndex) => {
                                    const steps = [
                                      "Work Initiated",
                                      "Recce",
                                      "Manufacturing",
                                      "Installation",
                                    ];

                                    return (
                                      <div
                                        key={pIndex}
                                        className="bg-gray-100 rounded-lg p-4"
                                      >
                                        <div className="font-semibold mb-4">
                                          {product.productType}
                                        </div>

                                        <div className="relative border-l-2 border-gray-300 pl-6">
                                          {steps.map((step, stepIndex) => {
                                            const isCompleted =
                                              product.currentStep >= stepIndex;

                                            return (
                                              <div
                                                key={stepIndex}
                                                className="mb-6 relative"
                                              >
                                                <div
                                                  className={`absolute -left-3 w-6 h-6 flex items-center justify-center rounded-full border-2 ${
                                                    isCompleted
                                                      ? "bg-blue-600 border-blue-600 text-white"
                                                      : "bg-white border-gray-300 text-gray-400"
                                                  }`}
                                                >
                                                  {isCompleted ? "✓" : "?"}
                                                </div>

                                                <div className="ml-4">
                                                  <div className="font-medium text-gray-800">
                                                    {step}
                                                  </div>
                                                  {product.timeline?.[step]
                                                    ?.date && (
                                                    <div className="text-xs text-gray-500">
                                                      {
                                                        product.timeline[step]
                                                          .date
                                                      }
                                                    </div>
                                                  )}
                                                </div>
                                              </div>
                                            );
                                          })}
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              </td>
                            </tr>
                          )} */}
                          </React.Fragment>
                        );
                      })}
                    </tbody>
                  ));
                })()}
              </table>
              <ReportModal
                selectedJob={selectedJob}
                setSelectedJob={setSelectedJob}
                isModalOpen={isModalOpen}
                setIsModalOpen={setIsModalOpen}
                CampaignDetails={CampaignDetails}
                getCampaignDetails={getCampaignDetails}
              />
            </div>
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
};

export default ProjectTimeline;

// const groupByStateNameAndMergeProducts = (jobs) => {
//   // Step 1: Group by stateName
//   const groupedByState = jobs.reduce((acc, job) => {
//     const stateName = job?.state; // Safely access state
//     const productId = job?.productId; // Safely access productId

//     if (stateName && productId) {
//       if (!acc[stateName]) {
//         acc[stateName] = {}; // Initialize the state group if not present
//       }
//       if (!acc[stateName][productId]) {
//         acc[stateName][productId] = []; // Initialize productId group within state
//       }
//       acc[stateName][productId].push(job); // Add job to the correct productId group
//     }
//     return acc;
//   }, {});

//   // Step 2: Convert grouped object into an array format and sort by stateName
//   const result = Object.entries(groupedByState)
//     .sort(([stateA], [stateB]) =>
//       stateA.localeCompare(stateB, undefined, { sensitivity: "base" })
//     )
//     .map(([stateName, products]) => ({
//       stateName,
//       products: Object.entries(products).map(([productId, jobs]) => ({
//         productId,
//         jobs, // Merged jobs for this productId
//       })),
//     }));

//   return result;
// };

const groupByStateCityAndStore = (jobs) => {
  // Step 1: Group jobs by state → city → store
  const groupedByState = jobs.reduce((acc, job) => {
    const stateName = job?.state;
    const city = job?.city;
    const address = job?.address;
    const storeName = job?.storeName;

    if (!stateName || !city || !address) return acc;

    if (!acc[stateName]) acc[stateName] = {};
    if (!acc[stateName][city]) acc[stateName][city] = [];

    // Check if store already exists
    let store = acc[stateName][city].find(
      (s) => s.address === address && s.storeName === storeName,
    );

    if (!store) {
      store = {
        id: `${stateName}-${city}-${storeName}-${address}`, // unique store id

        storeName,
        address,
        city,
        ownerName: job?.storeOwnerName,
        ownerPhone: job?.storeOwnerPhoneNumber,
        zipCode: job?.zipCode,
        products: [],
      };
      acc[stateName][city].push(store);
    }

    // Push product into store
    store.products.push({
      productId: job?.productId,
      productType: job?.productType,
      servicesNeeded: job?.servicesNeeded,
      jobs: [job], // keep original job info if needed
      vendorId: job?.vendorId,
    });

    return acc;
  }, {});

  // Step 2: Convert to array format
  return Object.entries(groupedByState).map(([stateName, cities]) => ({
    stateName,
    cities: Object.entries(cities).map(([cityName, stores]) => ({
      cityName,
      stores,
    })),
  }));
};
